import { Injectable, signal } from '@angular/core';
import { Subject } from 'rxjs';
import { ViewReportMode } from 'src/app/common/enums/enums';

/** Lets deeply-nested components request a tab switch on the already-open reports-menu dialog without a direct component reference. */
@Injectable({ providedIn: 'root' })
export class ReportsMenuNavigationService {
	private readonly _viewModeRequested = new Subject<ViewReportMode>();
	readonly viewModeRequested$ = this._viewModeRequested.asObservable();

	requestViewMode(mode: ViewReportMode): void {
		this._viewModeRequested.next(mode);
	}

	/** Which `${threadId}:${assetId}` pairs have a publish request in flight — lives here so the guard survives callers being destroyed and recreated. */
	private readonly inFlightAssetKeys = signal<ReadonlySet<string>>(new Set());

	markInFlight(threadId: string, assetId: string): void {
		const key = `${threadId}:${assetId}`;
		this.inFlightAssetKeys.update(keys => new Set(keys).add(key));
	}

	clearInFlight(threadId: string, assetId: string): void {
		const key = `${threadId}:${assetId}`;
		this.inFlightAssetKeys.update(keys => {
			if (!keys.has(key)) return keys;
			const next = new Set(keys);
			next.delete(key);
			return next;
		});
	}

	isInFlight(threadId: string, assetId: string): boolean {
		return this.inFlightAssetKeys().has(`${threadId}:${assetId}`);
	}
}
